import { type MouseEvent } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import logo from '../../assets/images/logo160.png';
import facebookIcon from '../../assets/icons/Facebook.png';
import instagramIcon from '../../assets/icons/Instagram.png';
import linkedInIcon from '../../assets/icons/LinkedIn.png';
import './footer.scss';

function Footer() {
    const { pathname } = useLocation();
    const scrollToTopIfCurrentPage = (destination: string, event: MouseEvent) => {
        if (pathname !== destination) {
            return;
        }

        event.preventDefault();
        document.querySelector('.page-viewport')?.scrollTo({ top: 0, behavior: 'smooth' });
    };

  return (
    <footer className="site-footer">
        <div className="footer-top">
            <div className="footer-brand">
                <img src={logo} alt="MSIA Logo" className="footer-logo" />
                <div>
                    <p className="footer-brand-title">Missouri</p>
                    <p className="footer-brand-title">Self-Insurers Association</p>
                </div>
            </div>

            <div className="footer-columns">
                <div className="footer-column">
                    <h3>Contact Us</h3>
                    <ul>
                        <li>
                            <span className="footer-icon">📍</span> 101 E. High St., First Floor<br />
                            <span className="footer-address-line">Jefferson City, MO 65101</span>
                        </li>
                        <li>
                            <span className="footer-icon">📞</span>{' '}
                            <a className="footer-contact-link" href="tel:+15736347144">(573) 634-7144</a>
                        </li>
                        <li>
                            <span className="footer-icon">✉️</span>{' '}
                            <a className="footer-contact-link" href="mailto:info@msia-mo.org`">info@msia-mo.org</a>
                        </li>
                        {/* <li>
                            <a href="https://www.facebook.com" target="_blank" rel="noreferrer" className="footer-social">
                                <span className="footer-icon">🔗</span> facebook
                            </a>
                        </li> */}
                    </ul>
                </div>

                <div className="footer-column footer-column--links">
                    <h3>Links</h3>
                    <ul>
                    <li><NavLink to="/contact" onClick={(event) => scrollToTopIfCurrentPage('/contact', event)}>Contact</NavLink></li>
                    <li><NavLink to="/schedule" onClick={(event) => scrollToTopIfCurrentPage('/schedule', event)}>Schedule</NavLink></li>
                    <li><NavLink to="/sponsors" onClick={(event) => scrollToTopIfCurrentPage('/sponsors', event)}>Sponsors</NavLink></li>
                    {/* <li><a href="/policies">Site Policies/Disclaimer</a></li> */}
                    </ul>
                </div>

                <div className="footer-column footer-column--socials">
                    <h3>Socials</h3>
                    <ul className="footer-social-list">
                        <li>
                            <a
                                href="https://www.facebook.com/MSIA-Missouri-Self-Insurers-Association"
                                target="_blank"
                                rel="noreferrer"
                                className="footer-social"
                            >
                                <img src={facebookIcon} alt="Facebook" className="footer-social-icon" />
                                <span>MSIA-Missouri Self-Insurers Association</span>
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.instagram.com/moselfinsurersassociation"
                                target="_blank"
                                rel="noreferrer"
                                className="footer-social"
                            >
                                <img src={instagramIcon} alt="Instagram" className="footer-social-icon" />
                                <span>@moselfinsurersassociation</span>
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.linkedin.com/company/missouriselfinsurersassociation"
                                target="_blank"
                                rel="noreferrer"
                                className="footer-social"
                            >
                                <img src={linkedInIcon} alt="LinkedIn" className="footer-social-icon" />
                                <span>Company/Missouriselfinsurersassociation</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div className="footer-bottom">
            <p>All Rights Reserved © Copyright 2021 MSIA</p>
        </div>
    </footer>
  );
}

export default Footer;
